import {
    createPDFThumbnail
} from '@helpers/pdf-thumbnail';

import {
    getExifData,
    getExifDataHeic
} from '@helpers/jpeg-exif';

import {
    rotateImageFromFile
} from '@helpers/image-rotation'

import { useUrl as setHeifUrl, convertHeif } from 'libheif-web';

setHeifUrl(
    (typeof process !== 'undefined' && process?.env?.FORMITIZE_ROOT ? process.env.FORMITIZE_ROOT : '/') + 'resources/modern/js/libheif.min.js',
);


const createPlugin = (
    process = async (file) => {}, 
) => {
    return (file) => {
        return process(file).catch(
            (err) => {
                console.log(`plugin error ${err}`);
                return false;
            }
        )
    };
}


//future note - if we run into concurrency issues here we can add a mutex lock.
const PDFThumbnailPlugin = createPlugin(
    async (file) => {
        try {
            if(!(file.name.toLowerCase().endsWith(".pdf"))) return false;
            const thumbnail = await createPDFThumbnail(file).catch(
                (err) => {
                    console.log(`pdfjs error ${err}`);
                    return false;
                }
            );
            if(!thumbnail) return false;
            return {
                extra: {
                    thumbnail
                }
            };
        } catch(ex) {
            return false;
        }
    }
);

const HEIFToJPEGPlugin = createPlugin(
    async (file) => {
        if(!(file.name.toLowerCase().endsWith(".heic") || file.name.toLowerCase().endsWith(".heif"))) return false;
        try {
            
            const image = await convertHeif(
                file,
                file.name.replace(/\.heic|\.heif/, '.jpg'),
                'image/jpeg'
            );
            return {
                file: image
            };
        } catch(ex) {
            return false;
        }
    }
)

const makeFilenameFriendlyPlugin = createPlugin(
    async (file) => {
        const newFilename = file.name.replace(/[^a-zA-Z0-9\.\-+]/g, '_');
        if(newFilename !== file.name) {
            return {
                file: new File([file], newFilename, {type: file.type})
            }
        }
        return false;
    }
)

    
const JPEGRotationPlugin = createPlugin(
    async (file) => {
        if(
            !(
                file.name.toLowerCase().endsWith(".jpg") || file.name.toLowerCase().endsWith(".jpeg") ||
                file.name.toLowerCase().endsWith(".heic") || file.name.toLowerCase().endsWith(".heif")
            )
        )  return false;
        try {
            const exif = (file.name.toLowerCase().endsWith(".heic") || file.name.toLowerCase().endsWith(".heif")) ?
                    await getExifDataHeic(file).catch((err) => err): 
                    await getExifData(file).catch((err) => err);

            if(!exif) return false;

            if(exif.Orientation) {
                const newFileBlob = await rotateImageFromFile(file).catch( (err) => false );
                if(newFileBlob === false) return;

                return {
                    file: new File([newFileBlob], file.name, {type: 'image/jpeg'})
                }
            }
            return false;
        } catch(ex) {
            return false;
        }

    }
)

export {
    makeFilenameFriendlyPlugin,
    createPlugin,
    PDFThumbnailPlugin,
    JPEGRotationPlugin,
    HEIFToJPEGPlugin
}